<template>
  <div>
    <abstractTable 
      :columns="shiftsColumns" 
      :data="formattedShifts()"
      :classes="'ui very compact center aligned celled table'"
      v-if="formattedShifts().length"
    />
    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          There are no shifts started for this room.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    shifts: { type: Array, required: true },
  },
  computed: {
    shiftsColumns () {
      return [
        { header: 'Doctor', fieldName: 'doctorName', show: true },
        { header: 'Started at', fieldName: 'started_at', show: true },
        { header: 'Finished at', fieldName: 'finished_at', show: true }
      ]
    }
  },
  methods: {
    formattedShifts () {
      return this.shifts.map(shift => ({
        doctorName: this.getDoctorName(shift.doctor_id),
        started_at: shift.started_at ? this.timeFormat(shift.started_at) : '-',
        finished_at: shift.finished_at ? this.timeFormat(shift.finished_at) : '-'
      }))
    },
    getDoctorName (doctorId) {
      return this.doctorsMeta.find(doctorId).user.name
    },
    timeFormat (time) {
      return window.moment(time).format('LLLL')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rooms/room_components/shifts_component/Shifts.vue